import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-barn-brown text-white z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="text-center text-gray-300">
          <p className="font-semibold text-xs">River Styx Cider Mill | 8058 River Styx Rd, Wadsworth OH 44281</p>
          <p className="text-xs">&copy; 2025 River Styx Cider Mill. All rights reserved.</p>
          <p className="text-xs">
            Established 1975 | Celebrating 50 Years of Operation | Family Tradition Since Day One
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;